<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        นำส่งข้อมูลรายการส่งเสริมการขายเพื่อการกำกับดูแล
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i>นำส่งข้อมูลรายการส่งเสริมการขายเพื่อการกำกับดูแล
          </a>
        </li>
        <li class="active">นำส่งข้อมูลรายการส่งเสริมการขายเพื่อการกำกับดูแล</li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header with-border">
                <div class="layout_filter_search">
                  <h2>อัปโหลดไฟล์รายการส่งเสริมการขาย</h2>
                </div>
              </div>
              <div class="box-body">
                <div class="wrapper_uploadsave">
                  <el-form size="mini">
                    <div class="row">
                      <div class="col-sm-6">
                        <el-form-item label="ประเภทรายการส่งเสริมการขาย">
                          <el-select
                            style="width: 100%;"
                            size="medium"
                            v-model="type"
                            placeholder="กรุณาเลือกประเภทของรายการส่งเสริมการขาย"
                            :disabled="true"
                          >
                            <el-option label="โทรศัพท์เคลื่อนที่" value="mobile"></el-option>
                            <el-option label="อินเทอร์เน็ตความเร็วสูงประจำที่" value="broadband"></el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                      <div class="col-sm-6">
                        <el-form-item label="รอบการส่งข้อมูลประจำเดือน (เดือน/ปี)" required>
                          <el-date-picker
                          @change="pickDate"
                          :disabled="!picker"
                            style="width: 100%;"
                            size="medium"
                            ref="picker"
                            v-model="monthly"
                            placeholder="รอบการส่งข้อมูลประจำเดือน (เดือน/ปี)"
                            type="month"
                            :picker-options="pickerOptions"
                          ></el-date-picker>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-6">
                        <el-upload
                          type="file"
                          class="upload-demo"
                          ref="uploadInput"
                          action="#"
                          :on-change="onFileChange"
                          :file-list="fileList"
                          :auto-upload="false"
                          :limit="1"
                          :on-remove="removeFile"
                          :disabled="!monthly"
                          accept=".xls,.xlsx"
                        >
                        <el-button
                          slot="trigger"
                          size="medium"
                          type="primary"
                          :disabled="!monthly"
                        >เลือกไฟล์ EXCEL เท่านั้น</el-button>
                        <el-button
                          style="margin-left: 10px;"
                          size="medium"
                          type="success"
                          :disabled="dis"
                          @click="submitUpload"
                        >อัปโหลด</el-button>
                        </el-upload>
                      </div>
                    </div>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import moment from "moment"
export default {
  data() {
    return {
      btnUpload: true,
      dis: true,
      picker : true,
      monthly: "",
      type: "",
      provider_id : null,
      user_id : null,
      formData : null,
      fileList : [],
      pickerOptions: {
        disabledDate(time) {
        return time.getTime() > Date.now()
      },
      },
      temp : null,
      imported_date: [1590944400000]
    };
  },
  mounted(){
    this.$store.dispatch('Manage_internet/get_user_info'),
    this.$store.dispatch('Manage_internet/get_monthly_regulate', {page : 1, pageSize : 1})
    this.type = this.$cookies.get('user_nbtc').provider_type
    this.provider_id = this.$cookies.get('user_nbtc').provider_id
    this.admin_id = this.$cookies.get('user_nbtc').admin_id
  },
  computed: {
    ...mapState({
      store_history : store => store.Manage_internet.histories
    })
  },
  watch: {
    store_history : {
      handler : function(reload) {
        if(reload.length){
          const last_month = moment(reload[0], 'MM/YYYY').subtract(543, 'Y')
          this.monthly = moment(last_month).add(1,'M')
          this.$store.commit('Manage_internet/PICK_MONTH', this.monthly)
          this.picker = false
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      UPDATE_ROW: "Promotion/UPDATE_ROW",
      SAVE_DATA: "Promotion/SAVE_DATA",
      CHANGE_FileForm: "Promotion/CHANGE_FileForm",
      CHANGE_dateMonthly: "Promotion/CHANGE_dateMonthly"
    }),
    ...mapActions({
      mobileMonthly: "Promotion/mobileMonthly",
      broadbandMonthly: "Manage_internet/analyzeFile",
      previewPromotions: "Promotion/previewPromotions"
    }),
    disbutton() {
      if(!this.monthly){
        return false
      }
      let pickMonth = moment(this.monthly).format('YYYY-MM')
      if(this.monthly.getTime() < 1514739600000){
        this.MessageBox("แจ้งเตือน","กรุณานำเข้าข้อมูลตั้งแต่ 2561-01 เป็นต้นไป","warning");
        this.monthly = null
      }else if(this.store_history.length){
        let last = this.store_history[this.store_history.length-1]
        let require = moment(last, 'MM/YYYY').add(1,'M').format('YYYY-MM')
        if(this.store_history.includes(pickMonth)){
          this.MessageBox("แจ้งเตือน","เดือน "+pickMonth+" ได้มีการนำส่งข้อมูลรายเดือนอยู่แล้ว","warning");
          this.monthly = null
        }else if(moment(this.monthly).add(543,'Y').format('YYYY-MM') !== require){
          this.MessageBox("แจ้งเตือน","เดือนที่ต้องนำส่งข้อมูลล่าสุดคือ "+require,"warning");
          this.monthly = null
        }
      }else if(this.monthly.getTime() !== 1514739600000){
        this.MessageBox("แจ้งเตือน","กรุณานำเข้าข้อมูลตั้งแต่ 2561-01 เป็นต้นไป","warning");
        this.monthly = null
      }
      this.btnUpload = (this.monthly) ? false : true
      if(this.btnUpload) this.dis = true
    },
    onFileChange(obj) {
      let file = obj.raw
      this.temp = file.name
      if (this.type == "mobile") {
        if (file.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
          this.formData = null;
          this.formData = new FormData();
          this.formData.append("typeFile", "monthly");
          this.formData.append("file", file);
          this.CHANGE_dateMonthly(this.monthly);
          this.dis = false;
        } else {
          this.MessageBox("แจ้งเตือน","กรุณาอัปโหลดเฉพาะไฟล์ Excel (นามสกุลไฟล์ .xlsx)","warning");
        }
      } else { // === broadband
        if (file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
          this.formData = new FormData()
          this.formData.append('typeFile','monthly')
          this.formData.append('provider_id',this.provider_id)
          this.formData.append('admin_id',this.admin_id)
          this.formData.append('created_promotion_from','monthly')
          this.formData.append('pickMonth',this.monthly)
          this.formData.append('file',file)
          this.dis = false
        }else{
          this.MessageBox("แจ้งเตือน","กรุณาอัปโหลดเฉพาะไฟล์ Excel (นามสกุลไฟล์ .xlsx)","warning");
        }
      }
    },
    removeFile(e){
      this.dis = true
      this.temp = null
    },
    pickDate(month){
      var th_month = moment(month).add(543,'Y').format('MM/YYYY')
      if(this.store_history.includes(th_month)){
        this.MessageBox("แจ้งเตือน","เดือน "+th_month+" ได้มีการนำส่งแล้ว","warning");
        this.monthly = null
      }else{
        this.$store.commit('Manage_internet/PICK_MONTH', this.monthly)
      }
      if(!this.monthly){
        this.dis = true
      }else if(this.temp){
        this.dis = false
      }
    },
    submitUpload() {
      if(!this.monthly) return this.MessageBox("แจ้งเตือน","กรุณาเลือกรอบการส่งข้อมูลประจำเดือน","warning");
      if(this.type === 'broadband'){
        this.formData.path = 'Add_uploadsave'
        this.broadbandMonthly(this.formData)
      }else{ // === mobile
        this.previewPromotions(this.formData);
        let file = this.temp;
        this.CHANGE_FileForm(file);
        this.CHANGE_dateMonthly(this.monthly);
      }
    }
  }
}
</script>
